import { Controller } from '@hotwired/stimulus';

const EMAIL_PATTERN = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

export default class extends Controller {
  static targets = ['checkbox', 'email'];

  static values = { serverReady: Boolean };

  sync() {
    if (this.serverReadyValue) return;

    const valid = EMAIL_PATTERN.test(this.emailTarget.value.normalize('NFKC').trim());
    this.checkboxTarget.disabled = !valid;
    this.checkboxTarget.checked = valid;
  }
}
